import moment from 'moment';
import { dateFormatRegionMap } from '../../constants/dateFormat';
import { useDateFnsLocale } from './useLocale';

const useFormatDatePicker = () => {
    const CURRENT_YEAR = new Date().getFullYear();
    const storedLocale = localStorage.getItem('mvc-date-locale') || 'en-US';
    const dateFnsLocale = useDateFnsLocale(storedLocale);
    const formatStr = dateFormatRegionMap[storedLocale].short;
    const momentFormatStr = dateFormatRegionMap[storedLocale].moment.short;

    const formatDate = (date: Date | string) => {
        if (typeof date === 'string') {
            date = new Date(date);
        }
        return moment(date).format(momentFormatStr);
    };

    const parseDate = (str: string): Date | undefined => {
        const date = moment(str, momentFormatStr).toDate();
        if (moment.isDate(date) && Number.isInteger(date.getTime())) {
            return date;
        }
        return undefined;
    };

    return {
        formatDate,
        CURRENT_YEAR,
        parseDate,
        format: formatStr,
        locale: dateFnsLocale,
    };
};

export default useFormatDatePicker;
